import { useBoolean } from "@mychili/ui-web";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useOrder } from "../../entities/order";
import { isMobile } from "../../shared/lib/device";
import { LoadingView, PaymentStatusView } from "../../shared/ui";
import { LayoutMain } from "../../widgets/layout-main";
import { PaymentViewDesktop } from "./payment-view-desktop";
import { PaymentViewMobile } from "./payment-view-mobile";

export const PaymentPage = () => {
  const [searchParams] = useSearchParams();
  const onlineOrderId = searchParams.get("onlineOrderId") ?? undefined;

  const { value: isPolling, off: stopPolling } = useBoolean(true);

  const { data, isLoading } = useOrder({
    onlineOrderId,
    refetchInterval: isPolling ? 5000 : false,
  });

  useEffect(() => {
    let redirectUrl: string | null | undefined;

    if (
      data?.online_order_status &&
      ["PAYMENT_SUCCESSFUL", "CANCELLED", "UNAVAILABLE"].includes(
        data?.online_order_status,
      )
    ) {
      stopPolling();
    }

    if (data?.online_order_status === "PAYMENT_SUCCESSFUL") {
      redirectUrl =
        data?.redirect_urls?.success_redirect_url ?? data.website_url;
    }

    if (data?.online_order_status === "CANCELLED") {
      redirectUrl =
        data?.redirect_urls?.failed_redirect_url ?? data.website_url;
    }

    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [
    data?.online_order_status,
    data?.website_url,
    data?.redirect_urls,
    stopPolling,
  ]);

  if (isLoading)
    return (
      <LayoutMain>
        <LoadingView />
      </LayoutMain>
    );

  if (!data || data.online_order_status === "REFUNDED")
    return (
      <LayoutMain>
        <PaymentStatusView status="UNAVAILABLE" />
      </LayoutMain>
    );

  const {
    link,
    link_qr,
    online_order_status,
    disallow_promocodes,
    is_web_flow_allowed,
  } = data;

  if (online_order_status === "PAYMENT_IN_PROGRESS")
    return (
      <LayoutMain>
        {isMobile ? (
          <PaymentViewMobile
            link={link}
            disallowPromocodes={disallow_promocodes}
            isWebFlowAllowed={is_web_flow_allowed}
          />
        ) : (
          <PaymentViewDesktop
            linkQr={link_qr}
            disallowPromocodes={disallow_promocodes}
            isWebFlowAllowed={is_web_flow_allowed}
          />
        )}
      </LayoutMain>
    );

  return (
    <LayoutMain>
      <PaymentStatusView
        status={online_order_status}
        redirectUrl={
          data?.redirect_urls?.cart_redirect_url ?? data?.website_url
        }
      />
    </LayoutMain>
  );
};
